module.exports = __webpack_public_path__ + "img/man-pie-chart.170e22b5.png";